export const summerizeText = (
  input: string | undefined | null,
  length: number
): string => {
  if (!input) return '';
  return input.length > length ? input.substring(0, length) + ' ...' : input;
};
